import { QuizQuestionData } from "./QuizQuestion";

export const quizQuestions: QuizQuestionData[] = [
  {
    id: 1,
    question: "What does 'Copy Trading' mean?",
    options: [
      { id: "A", text: "Buying an identical amount of cryptocurrency from a friend" },
      { id: "B", text: "Automatically replicating trades from an experienced trader" },
      { id: "C", text: "Printing out trading charts to analyze later" },
      { id: "D", text: "Creating a backup of your exchange account" }
    ],
    correctAnswer: "B",
    explanation: "Copy trading allows you to follow a pro trader's strategies; their moves are automatically replicated in your account."
  },
  {
    id: 2,
    question: "Which is a key benefit of copy trading?",
    options: [
      { id: "A", text: "Guaranteed profits with no risk" },
      { id: "B", text: "Learning advanced trading strategies without studying charts full-time" },
      { id: "C", text: "Getting instant VIP membership on all crypto exchanges" },
      { id: "D", text: "Avoiding the need to manage your own money" }
    ],
    correctAnswer: "B",
    explanation: "While copy trading doesn't guarantee profits, it lets you observe and learn from pro traders' moves without monitoring the market 24/7."
  },
  {
    id: 3,
    question: "Why might someone choose a METRADE Premium strategy over a free one?",
    options: [
      { id: "A", text: "Verified strategies are proven to never lose money" },
      { id: "B", text: "Free strategies are illegal in most countries" },
      { id: "C", text: "Verified strategies undergo expert review for consistent performance" },
      { id: "D", text: "Free strategies are only available once a year" }
    ],
    correctAnswer: "C",
    explanation: "Metrade Verified strategies are vetted by experts, giving you added confidence and advanced analytics compared to free, community-sourced strategies."
  },
  {
    id: 4,
    question: "When setting a risk level for copy trading, beginners should generally...",
    options: [
      { id: "A", text: "Pick the highest risk possible for quick gains" },
      { id: "B", text: "Choose a moderate or low risk until they're comfortable" },
      { id: "C", text: "Alternate randomly each day" },
      { id: "D", text: "Skip risk level selection to save time" }
    ],
    correctAnswer: "B",
    explanation: "Beginners often benefit from moderate or lower-risk strategies until they gain more trading experience and understand volatility."
  },
  {
    id: 5,
    question: "How do you actually execute trades when copy trading?",
    options: [
      { id: "A", text: "The strategy trades for you via a linked exchange account" },
      { id: "B", text: "You must manually copy all trades from a chat message" },
      { id: "C", text: "You upload a PDF of the trader's instructions" },
      { id: "D", text: "Trades are placed offline using a special hardware wallet" }
    ],
    correctAnswer: "A",
    explanation: "Copy trading typically happens through an automated connection to your crypto exchange, mirroring the trader's moves in real time."
  }
];
